export default __webpack_public_path__ + "static/media/exit-icon.e4c19b81.svg";